import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials} = useGLTF("/plots/10-Restaurant2.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
       <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube029.geometry}
        material={materials["02-BenchWood"]}
        position={[-0.662, 0.454, 0.247]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube035.geometry}
        material={materials["01-TreeTrunk"]}
        position={[-0.659, 0.201, 0.812]}
        rotation={[0, 1.058, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube190.geometry}
        material={materials["15-RestaurantAccent"]}
        position={[-0.064, 0.409, -0.001]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube281.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.45, 0.322, 0.511]}
        rotation={[0, -1.571, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube365.geometry}
        material={materials["00-Base4"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube423.geometry}
        material={materials["16-RestaurantWalls"]}
        position={[-0.449, 0.412, -0.173]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube434.geometry}
        material={materials["15-RestaurantShingles"]}
        position={[0.207, 0.919, -0.092]}
        rotation={[0, 0, -0.592]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube475.geometry}
        material={materials["11-SidewalkConcrete"]}
        position={[0.041, 0.101, 0.415]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube477.geometry}
        material={materials["00-Grass1"]}
        position={[-0.521, 0.099, -0.001]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube479.geometry}
        material={materials["15-RestaurantSill"]}
        position={[-0.45, 0.322, 0.511]}
        rotation={[0, -1.571, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube516.geometry}
        material={materials["15-RestaurantRailing"]}
        position={[-0.449, 0.506, 0.49]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder001.geometry}
        material={materials["15-RestaurantSign"]}
        position={[0.159, 0.663, -0.088]}
        scale={1.026}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere023.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.78, 0.423, -0.569]}
        rotation={[-2.983, 0.143, -2.439]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere024.geometry}
        material={materials["01-TreeGreen1"]}
        position={[-0.647, 0.43, 0.803]}
        rotation={[-1.12, -0.213, 2.218]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/10-Restaurant2.glb");
